import * as entity from '@common/domain/entities/AuditTrail'
import { IDataEndPoint } from '../../../framework/interfaces/IEntity';
import * as app from '@framework/app';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
export class AuditTrailReqEndPoints extends entity.AuditTrailEndPoints {
  search?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKey/Requisition/" + serviceCommand.context.entityId
    }, method: "POST"
  };
  pagingTotalCount?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKeyCount/Requisition/" + serviceCommand.context.entityId
    }, method: "POST"
  };
}
export class AuditTrailReqItemEndPoints extends entity.AuditTrailEndPoints {
  search?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKey/Requisition/" + serviceCommand.context.entityId
    }, method: "POST"
  };
  pagingTotalCount?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKeyCount/Requisition/" + serviceCommand.context.entityId
    }, method: "POST"
  };
}

export class AuditTrailFormFields extends entity.AuditTrailFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class AuditTrailForm extends entity.AuditTrailForm {
  protected auditTrailFormEndPoints: AuditTrailReqEndPoints = new AuditTrailReqEndPoints();
  protected auditTrailFormFields: AuditTrailFormFields = new AuditTrailFormFields();
}

export class AuditTrailListColumns extends entity.AuditTrailListColumns {
  constructor() {
    super();
    try {
      if (this["userId"]) this["userId"].visible = false;
      if (this["id"]) this["id"].visible = false;
      this.splice(this.indexOf(this.auditTrailCommentId), 1);
      this.splice(this.indexOf(this.auditType), 1);
      this.splice(this.indexOf(this.auditTypeIdentifier), 1);
      this.splice(this.indexOf(this.columnDataType), 1);
      this.splice(this.indexOf(this.primaryKeyName), 1);
      this.splice(this.indexOf(this.primaryKeyValue), 1);
      this.splice(this.indexOf(this.tableName), 1);
      this.splice(this.indexOf(this.oldValue), 1);
      this.splice(this.indexOf(this.newValue), 1);
      this.deleteAction.name = "Deleted";
      this.createAction.name = "Created";
      this.updateAction.name = "Updated";
      let user = FormBuilderControlListHelper.getListColumn("userId", "User", null, null, "user_formatted");
      this.push(user);
      this.push(this.oldValue);
      this.push(this.newValue);
      let comments = FormBuilderControlListHelper.getListColumn("auditTrailComment.comments", "Comments", null, null, "auditTrailComment_comments");
      //comments.visible = false;
      this.push(comments); 
    } catch  { }
  }
}

export class AuditTrailReqList extends entity.AuditTrailList {
  protected auditTrailListEndPoints: AuditTrailReqEndPoints = new AuditTrailReqEndPoints();
  protected auditTrailListColumns: AuditTrailListColumns = new AuditTrailListColumns();
  public autoSizeColumns: boolean = true; // when autosizing it removes resizable columns + fixed scrolling
  public tableIsGrouped: boolean = true;
  public groupingField: string = 'auditTrailComment_comments';
  public canAdd: boolean = false;
  public dataSortedByGroup: boolean = true;
  public autoExpandRows: boolean = false;
  public disableNavigation: boolean = true;
}

export class AuditTrailReqItemList extends entity.AuditTrailList {
  protected auditTrailListEndPoints: AuditTrailReqItemEndPoints = new AuditTrailReqItemEndPoints();
  protected auditTrailListColumns: AuditTrailListColumns = new AuditTrailListColumns();
  public autoSizeColumns: boolean = true;// when autosizing it removes resizable columns + fixed scrolling
  public tableIsGrouped: boolean = true;
  public groupingField: string = 'auditTrailComment_comments';
  public canAdd: boolean = false;
  public dataSortedByGroup: boolean = true;
  public autoExpandRows: boolean = false;
  public disableNavigation: boolean = true;
}


export class AuditTrailStockItemEndPoints extends entity.AuditTrailEndPoints {
  search?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKey/StockItem/" + serviceCommand.context.entityId
    }, method: "POST"
  };
  pagingTotalCount?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKeyCount/StockItem/" + serviceCommand.context.entityId
    }, method: "POST"
  };
}
export class StockItemList extends entity.AuditTrailList {
  protected auditTrailListEndPoints: AuditTrailStockItemEndPoints = new AuditTrailStockItemEndPoints();
  protected auditTrailListColumns: AuditTrailListColumns = new AuditTrailListColumns();
  public autoSizeColumns: boolean = true; // when autosizing it removes resizable columns + fixed scrolling
  public canAdd: boolean = false;
  public disableNavigation: boolean = true;
}


export class AuditTrailStockItemSupplierEndPoints extends entity.AuditTrailEndPoints {
  search?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKey/StockItem/" + serviceCommand.context.entityId
    }, method: "POST"
  };
  pagingTotalCount?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/auditTrail/lazyPrimaryKeyCount/StockItem/" + serviceCommand.context.entityId
    }, method: "POST"
  };
}
export class StockItemSupplierList extends entity.AuditTrailList {
  protected auditTrailListEndPoints: AuditTrailStockItemSupplierEndPoints = new AuditTrailStockItemSupplierEndPoints();
  protected auditTrailListColumns: AuditTrailListColumns = new AuditTrailListColumns();
  public autoSizeColumns: boolean = true;// when autosizing it removes resizable columns + fixed scrolling
  public canAdd: boolean = false;
  public disableNavigation: boolean = true;
}


